
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import { TeamModel } from '../models/team';
import { teamDashboardStore } from '../store';
import Page from '../views/Page.vue';
import CalendarV2 from '../components/calendar/CalendarV2.vue';
import TeamDetailsCard from '../components/teams/TeamDetailsCard.vue';
import PlayerManagement from '../components/teams/PlayerManagement.vue';
import { CurrentTeamMixin, LocalForageMixin, MyCoachMixin, AppHostnameMixin, StringsMixin } from '../mixins';
import { CalendarMode } from '../components/calendar/types/CalendarMode';
import { DepthChartModel } from '../models/depthChart';
import CalendarProvider from '@/components/hoc/CalendarProvider.vue';
import TeamDashboardInfoProvider from '@/components/hoc/TeamDashboardInfoProvider.vue';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import * as Routes from '@/../types/constants/web_client_user.routes';
import { VCalendarDay } from '@/components/calendar/types/VCalendarDay';

@Component({
	components: {
		CalendarProvider,
		CalendarV2,
		TeamDashboardInfoProvider,
		Page,
		PlayerManagement,
		TeamDetailsCard,
	}
})
export default class TeamDashboard extends Mixins(CurrentTeamMixin, LocalForageMixin, AppHostnameMixin, StringsMixin, MyCoachMixin){
	season: string = "2020";

	@Prop() teamId: string;
	@Prop({ default: false, type: Boolean }) athleteMode: boolean;

	get PlayerManagementProps(): Record<string, any>{
		if(this.AthleteAppActive){
			return {
				team: this.team,
				tabs: this.AthleteModeTabs,
				readOnly: this.AthleteAppActive,
			};
		}
		return {
			team: this.team,
		};
	}

	get AthleteModeTabs(): string[]{
		return [
			'roster'
		];
	}

	localForagePersistFields: Array<string | [string, any]> = [
		['calendarMode', CalendarMode.Agenda],
	];
	calendarMode: CalendarMode = CalendarMode.Agenda;
	updateCalendarMode(mode: CalendarMode): void{
		this.calendarMode = mode;
		this.persistField('calendarMode');
	}

	@Watch('teamId') updateTeamId(): void{
		this.loadTeamFromUrl();
	}

	async created(): Promise<void> {
		await this.loadTeamFromUrl();
	}

	async loadTeamFromUrl(): Promise<void>{
		await teamDashboardStore.loadTeam(this.teamId);

		if( this.CoachAppActive ) {
			if( this.IsNotEmpty(this.MyCoachProfile?.teams ) ) {
				const i = this.MyCoachProfile.teams.findIndex(t => t === this.teamId);
				if( i > 0 ) this.moveCoachTeam(i, 0);
			}
		}
	}

	get PageLoading(): boolean{
		return !teamDashboardStore.initialized || teamDashboardStore.loadingTeam;
	}
	get team(): TeamModel {
		return teamDashboardStore.team;
	}
	get depthCharts(): DepthChartModel[] {
		return teamDashboardStore.team.depthCharts;
	}
	expandCalendar(): void{
		this.$router.push({
			name: Routes.FullScreenCalendar,
			params:{
				teamId: this.teamId
			}
		});
	}
	collapseCalendar() {
		if (this.AthleteAppActive){
			this.$router.push({
				name: Routes.AthleteTeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		} else {
			this.$router.push({
				name: Routes.TeamDashboardCalendar,
				params: { teamId: this.teamId },
			})
		}
	}
	changeTeam(team: TeamModel): void{
		this.$router.push({
			name: 'TeamDashboard',
			params: { teamId: team.id },
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		}).catch(() => {});
		this.loadTeamFromUrl();
	}

	addEvent({ focusDate }: { focusDate?: string }): void{		
		if(this.AthleteAppActive) return;
		this.$router.push({
			name: Routes.TeamEventCreate,
			params:{
				...this.$route.params,
			},
			query:{
				focusDate,
			}
		});
	}

	eventClicked({calendarEvent, $event}: {calendarEvent: CalendarEventModel,  $event: VCalendarDay<CalendarEventModel>}): void{
		// Replace - with spaces to avoid it being converted to UTC date because we want the local date
		// Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#timestamp_string
		let date = '';
		if ($event){
			date = new Date($event.day.date.replace(/-/g, "/")).toISOString()
		}else {
			date = calendarEvent.start.toISOString()
		}
		if(this.AthleteAppActive){
			this.$router.push({
				name: Routes.AthleteTeamEventView,
				params:{
					teamId: this.teamId,
					teamEventId: calendarEvent.id,
				},
				query: {
					focusDate: date
				}
			});
		}else{
			this.$router.push({
				name: Routes.TeamEventEdit,
				params:{
					teamId: this.teamId,
					teamEventId: calendarEvent.id,
				},
				query: {
					focusDate: date
				}
			});
		}
	}

}
